var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:no-null-keyword
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectResourceInfo } from "../../balancingSelectors/selectBalancingResources";
import { IdStyles } from "../../less/IdStyles";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { ButtonSellResource } from "../generic/common/ButtonSellResource";
import { TextLoca } from "../generic/text/TextLoca";
import { actionBuyProduct, actionSellProduct } from "../trade-component/actionTrade";
import { TradeComponent } from "../trade-component/TradeComponent";
import { IdTradePanelTab } from "./UIDefinitionTradePanel";
var TradeAreaDOM = /** @class */ (function (_super) {
    __extends(TradeAreaDOM, _super);
    function TradeAreaDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBuyTabContent = function () {
            var _a = _this.props, item = _a.item, maxStorage = _a.maxStorage, sliderValue = _a.sliderValue, tabs = _a.tabs, activeTabIndex = _a.activeTabIndex, onSliderChange = _a.onSliderChange;
            var _b = item.buyValue, resourceId = _b.resourceId, amount = _b.amount;
            var isStorageUnlimited = item.storageLimit === -1;
            var isButtonDisabled = isStorageUnlimited ? false : item.amount.equals(maxStorage);
            var soldResourceMaxAmount = isButtonDisabled
                ? Long.ZERO
                : isStorageUnlimited
                    ? Long.fromNumber(maxStorage)
                    : Long.fromNumber(maxStorage).subtract(item.amount);
            var soldResourceMinAmount = isButtonDisabled ? Long.ZERO : Long.ONE;
            var soldResourceInfo = selectResourceInfo(resourceId);
            var soldResourceAmount = sliderValue * amount;
            return (React.createElement("div", { className: "farm-management-detail__tabs-content " + IdStyles.FarmManagementTabBackground },
                React.createElement(TradeComponent, { purchasedResourceAmount: sliderValue, purchasedResourceInfo: item, onSliderChange: onSliderChange, sliderValue: sliderValue, wastedResourceAmount: soldResourceAmount, wastedResourceInfo: soldResourceInfo, wastedResourceMaxAmount: soldResourceMaxAmount, wastedResourceMinAmount: soldResourceMinAmount, backgroundStyle: IdStyles.InventoryBuyContainerCost }),
                React.createElement(ButtonPrimary, { disabled: isButtonDisabled, onClick: _this.onBuyButtonClick },
                    React.createElement("div", { className: IdStyles.TextButtonHeading },
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: tabs[activeTabIndex].locaKey })))));
        };
        _this.getSellTabContent = function () {
            var _a = _this.props, item = _a.item, sliderValue = _a.sliderValue, tabs = _a.tabs, activeTabIndex = _a.activeTabIndex, onSliderChange = _a.onSliderChange;
            var _b = item.sellValue, resourceId = _b.resourceId, amount = _b.amount;
            var isButtonDisabled = item.amount.equals(Long.ZERO);
            var soldResourceMinAmount = isButtonDisabled ? Long.ZERO : Long.ONE;
            var purchasedResourceInfo = selectResourceInfo(resourceId);
            var purchasedResourceAmount = sliderValue * amount;
            return (React.createElement("div", { className: "farm-management-detail__tabs-content " + IdStyles.FarmManagementTabBackground },
                React.createElement(TradeComponent, { purchasedResourceAmount: purchasedResourceAmount, purchasedResourceInfo: purchasedResourceInfo, onSliderChange: onSliderChange, sliderValue: sliderValue, wastedResourceAmount: sliderValue, wastedResourceInfo: item, wastedResourceMaxAmount: item.amount, wastedResourceMinAmount: soldResourceMinAmount, backgroundStyle: IdStyles.InventoryBuyContainerCost }),
                React.createElement(ButtonSellResource, { disabled: isButtonDisabled, onClick: _this.onSellButtonClick },
                    React.createElement("div", { className: IdStyles.TextButtonHeading },
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: tabs[activeTabIndex].locaKey })))));
        };
        _this.onSellButtonClick = function () {
            var _a = _this.props, onSellItem = _a.onSellItem, id = _a.item.id, sliderValue = _a.sliderValue;
            onSellItem(id, sliderValue);
        };
        _this.onBuyButtonClick = function () {
            var _a = _this.props, onBuyItem = _a.onBuyItem, id = _a.item.id, sliderValue = _a.sliderValue;
            onBuyItem(id, sliderValue);
        };
        return _this;
    }
    TradeAreaDOM.prototype.render = function () {
        var _a = this.props, tabs = _a.tabs, activeTabIndex = _a.activeTabIndex, item = _a.item;
        if (tabs[activeTabIndex].id === IdTradePanelTab.Buy && item.buyValue) {
            return this.getBuyTabContent();
        }
        else if (tabs[activeTabIndex].id === IdTradePanelTab.Sell && item.sellValue) {
            return this.getSellTabContent();
        }
        return null;
    };
    return TradeAreaDOM;
}(React.Component));
var mapDispatch = function (dispatch) { return ({
    onBuyItem: function (itemId, amount) { return dispatch(actionBuyProduct(itemId, amount)); },
    onSellItem: function (itemId, amount) { return dispatch(actionSellProduct(itemId, amount)); },
}); };
export var TradeArea = connect(undefined, mapDispatch)(TradeAreaDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/TradeArea.tsx
// module id = 2650
// module chunks = 3